import { getMXLocalDate } from "../utils/date.util";
import { getPostById, getPosts } from "../services/post.service";

export const postListComp = document.getElementById("post-list");
export const postDetailComp = document.getElementById("post-detail");
export const postsNotFound = document.getElementById("posts-notfound");
export const loadMoreButton = document.getElementById("load-more-btn");

export const postListItemComp = (post) => {
  const listItem = document.createElement("li");
  const cardComp = postCardComp(post);
  listItem.appendChild(cardComp);
  return listItem;
};

export const postDetailItemComp = (post) => {
  const title = document.getElementById("post-detail-title");
  const content = document.getElementById("post-detail-content");
  const imageUrl = document.getElementById("post-detail-img");
  const updatedAt = document.getElementById("post-detail-date");
  title.textContent = post.title;
  content.textContent = post.content;
  imageUrl.src = post.imageUrl;
  imageUrl.alt = post.title;
  updatedAt.textContent = getMXLocalDate(post.updatedAt);
  return {
    title,
    content,
    imageUrl,
    updatedAt,
  };
};

export const postCardComp = (post) => {
  const card = document.createElement("div");
  card.classList.add("card");
  card.classList.add("shadow-sm");
  card.classList.add("rounded-4");
  const img = document.createElement("img");
  img.src = post.imageUrl;
  img.classList.add("card-img-top");
  img.alt = "...";
  const cardBody = document.createElement("div");
  cardBody.classList.add("card-body");
  const cardTitle = document.createElement("h6");
  cardTitle.classList.add("card-title");
  cardTitle.textContent = post.title;
  const cardText = document.createElement("p");
  cardText.classList.add("card-text");
  cardText.textContent = `${post.content.substring(0, 125)}...`;
  const cardLink = document.createElement("a");
  cardLink.href = `post-detail.html?id=${post.id}`;
  cardLink.classList.add("btn", "btn-dark");
  cardLink.textContent = "Leer más";
  cardBody.appendChild(cardTitle);
  cardBody.appendChild(cardText);
  cardBody.appendChild(cardLink);
  card.appendChild(img);
  card.appendChild(cardBody);
  return card;
};

export const getPostList = async () => {
  try {
    if (postListComp) {
      const currentPage = 1;
      const pageSize = 9;
      const posts = await getPosts(currentPage, pageSize);
      if (posts && posts.length >= 0) {
        postsNotFound.style.display = 'none';
        for (const post of posts) {
          const postListItem = postListItemComp(post);
          postListComp.appendChild(postListItem);
        }
      } else {
        loadMoreButton.style.display = 'none';
        postsNotFound.style.display = 'block';
        postsNotFound.innerText = 'No se encontraron publicaciones';
      }
    }
  } catch (error) {
    console.error("Error fetching posts:", error);
  }
};

export const getPostDetail = async () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const postId = params.get("id");
    if (postId) {
      const post = await getPostById(postId);
      const { title, content, imageUrl, updatedAt } = postDetailItemComp(post);
      postDetailComp.appendChild(imageUrl);
      postDetailComp.appendChild(title);
      postDetailComp.appendChild(content);
      postDetailComp.appendChild(updatedAt);
    }
  } catch (error) {
    console.error("Error fetching post:", error);
  }
};
